import React from "react";
import { Button } from "@windmill/react-ui";

import useStaffSubmit from "hooks/useStaffSubmit";
import PageTitle from "components/common/PageTitle";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputArea";
import InputValue from "components/form/InputValue";
import Error from "components/form/Error";

const EditProfile = () => {
  const adminInfo = localStorage.getItem("adminInfo")  ? JSON.parse(localStorage.getItem("adminInfo"))
  : null;

  const { trigger,register, handleSubmit, onSubmit, errors } =
    useStaffSubmit(adminInfo.id);

  return (
    <>
      <PageTitle> Edit Profile"</PageTitle>
      <div className="container p-6 mx-auto bg-white  dark:bg-gray-800 dark:text-gray-200 rounded-lg">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="p-6 flex-grow scrollbar-hide w-full max-h-full">
            

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label="Name" />
              <div className="col-span-8 sm:col-span-4">
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label=" Name"
                      name="name"
                      type="text"
                      placeholder="Jhon"
                      pattern={/^[a-zA-Z]+$/}
                    />
                    <Error errorName={errors.name} />
                  </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label="Email" />
              <div className="col-span-8 sm:col-span-4">
                <InputValue
               trigger={trigger}
               register={register}
               label="Email"
               name="email"
               type="text"
               pattern={/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/}
               placeholder="jhon@gmail.com"
                />
                <Error errorName={errors.email} />
              </div>
            </div>

          
            </div>
          <div className="flex flex-row-reverse pr-6 pb-6">
            <Button type="submit" className="h-12 px-6">
              Update Profile
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default EditProfile;
